export default "__VITE_ASSET__DQ6uNOoV__"